import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let EXPORT;
if (process.env.NODE_ENV === 'production') {
  EXPORT = initialState => createStore(rootReducer, initialState, applyMiddleware(thunk));
} else {
  EXPORT = initialState => createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(thunk)));
}
export default EXPORT;
